import { Stack } from '@mui/material';
import _ from 'lodash';

import { api } from 'common';

import { BlockValueTemplateField } from '../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockSelectField } from '../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField';

const TYPES = Object.values(api.FlowDefinition.GetFormSetType);
const SEARCH_OPTIONS = Object.values(api.FlowDefinition.FormSetSearchScope);

export function GetFormSetFormFields() {
  const { value: type } =
    useSelectedNodeField<api.FlowDefinition.GetFormSetBlockConfig['type']>('config.type');
  return (
    <Stack spacing={2}>
      <BlockSelectField
        fieldName="config.type"
        label="Type"
        required
        options={TYPES.map((getFormSetType) => ({
          label: _.startCase(getFormSetType),
          value: getFormSetType,
        }))}
      />
      {type === api.FlowDefinition.GetFormSetType.UserDefined && (
        <BlockValueTemplateField fieldName="config.formSetId" label="Form Set ID" />
      )}
      {(type === api.FlowDefinition.GetFormSetType.AutomaticallyApplied ||
        type === api.FlowDefinition.GetFormSetType.AutomaticallyAppliedAll) && (
        <BlockSelectField
          fieldName="config.searchScope"
          label="Search Scope"
          options={SEARCH_OPTIONS.map((searchScope) => ({
            label: _.startCase(searchScope),
            value: searchScope,
          }))}
          required
          defaultValue={api.FlowDefinition.FormSetSearchScope.CurrentPractice}
          helperText="Defines where to search for form sets. 'Current Practice' searches within the practice of the entity that triggered the flow. 'Across EHR System' searches all linked practices where the patient has records, limited to organizations your account can access. Note: The 'Across EHR System' search only applies to patient entities - for other entity types, both options should return the same results."
        />
      )}
      {type === api.FlowDefinition.GetFormSetType.AutomaticallyAppliedAll && (
        <>
          <BlockValueTemplateField
            fieldName="config.after"
            label="After"
            helperText="The start date (inclusive) for which to filter returned form sets - formatted YYYY-MM-DD as per ISO 8601. If not provided, no start date filter will be applied."
          />
          <BlockValueTemplateField
            fieldName="config.before"
            label="Before"
            helperText="The end date (inclusive) for which to filter returned form sets - formatted YYYY-MM-DD as per ISO 8601. If not provided, no end date filter will be applied."
          />
          <BlockValueTemplateField
            fieldName="config.limit"
            label="Limit"
            helperText="Maximum number of form sets to return. Defaults to 10. Must be between 1 and 50."
          />
        </>
      )}
      <BlockValueTemplateField fieldName="config.formTemplateId" label="Form Template ID" />
      <BlockValueTemplateField fieldName="config.primitive" label="Primitive" />
    </Stack>
  );
}
